// keyboardTranslationUtils.ts

// מיפוי המקלדת מאנגלית לעברית
const englishToHebrewKeymap: Record<string, string> = {
  'q': '/',
  'w': "'",
  'e': 'ק',
  'r': 'ר',
  't': 'א',
  'y': 'ט',
  'u': 'ו',
  'i': 'ן',
  'o': 'ם',
  'p': 'פ',
  'a': 'ש',
  's': 'ד',
  'd': 'ג',
  'f': 'כ',
  'g': 'ע',
  'h': 'י',
  'j': 'ח',
  'k': 'ל',
  'l': 'ך',
  'z': 'ז',
  'x': 'ס',
  'c': 'ב',
  'v': 'ה',
  'b': 'נ',
  'n': 'מ',
  'm': 'צ',
  ',': 'ת',
  '.': 'ץ',
  '/': '.',
  ';': 'ף',
  "'": ',',
  '[': ']',
  ']': '[',
};

/**
 * פונקציה לתרגום טקסט מאנגלית לעברית לפי מיפוי המקלדת
 * @param text - הטקסט באנגלית לתרגום
 * @returns הטקסט המתורגם לעברית
 */
export const translateEnglishToHebrew = (text: string): string => {
  return text.toLowerCase().split('').map(char => {
    return englishToHebrewKeymap[char] || char;
  }).join('');
};

/**
 * פונקציה לבדיקה האם הטקסט מכיל אותיות באנגלית
 * @param text - הטקסט לבדיקה
 * @returns true אם הטקסט מכיל אותיות באנגלית, אחרת false
 */
export const isEnglishText = (text: string): boolean => {
  const englishCharsRegex = /[a-zA-Z]/;
  return englishCharsRegex.test(text);
};